module.exports = __webpack_public_path__ + "img/engelstrompete_3.d7551043.jpg";